const videoElements = document.getElementsByClassName('js-vid');

const initVideos = () => {
  if (videoElements) {
    for (let i = 0; i < videoElements.length; i++) {
      const el = videoElements[i];
      const video = el.querySelector('video');
      const playBtn = el.querySelector('[data-video-play]');

      if (playBtn) {
        playBtn.addEventListener('click', () => {
          if (video.paused) {
            playVideo(video, el);
          } else {
            pauseVideo(video, el);
          }
        }, false);
      }

      video.addEventListener('ended', () => {
        stopVideo(video, el);
      });
    }
  }
};

const playVideo = (video, parent) => {
  video.play();
  parent.classList.add('is-playing');
};

const pauseVideo = (video, parent) => {
  video.pause();
  parent.classList.remove('is-playing');
};

const stopVideo = (video, parent) => {
  parent.classList.remove('is-playing');
};

export {initVideos};
